import { render, staticRenderFns } from "./itemdetails.vue?vue&type=template&id=b6e6fa30&scoped=true"
import script from "./itemdetails.vue?vue&type=script&lang=js"
export * from "./itemdetails.vue?vue&type=script&lang=js"
import style0 from "./itemdetails.vue?vue&type=style&index=0&id=b6e6fa30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e6fa30",
  null
  
)

export default component.exports